module.exports = __webpack_public_path__ + "static/media/capture-img.b363222d.svg";